import _uniq from 'lodash-es/uniq'
import { loadScript } from '@/util/load_script'

export const initialize = () => {
  global.window.acConsent = {
    state: 'loading',
    load: maybeLoadSourcePoint
  }
  global.window.acConsent.loadingPromise = new Promise((resolve) => {
    global.window.acConsent.resolveLoadingPromise = resolve
  })

  global.window.acConsent.evalVendorsPromise = new Promise((resolve) => {
    global.window.acConsent.resolveEvalVendorsPromise = resolve
  })

  setTimeout(() => {
    if (global.window.acConsent.state === 'loading') { setSourcePointBlocked() }
  }, 5000)
}

export const isSourcepointBlocked = () => {
  return global.window.acConsent.state === 'blocked'
}

function waitForSourcePointConsent () {
  return Promise.all([global.window.acConsent.loadingPromise, global.window.acConsent.evalVendorsPromise])
}

function maybeLoadSourcePoint (url) {
  return loadScript(url).then((yay) => {
    global.window.acConsent.state = 'loaded'
    global.window.acConsent.resolveLoadingPromise()
  }).catch(() => {
    setSourcePointBlocked()
  })
}

function setSourcePointBlocked () {
  global.window.acConsent.state = 'blocked'
  global.window.acConsent.resolveLoadingPromise()
  global.window.acConsent.resolveEvalVendorsPromise()
}

export const registerConsent = ({ vendor, onAdd, onRemove }) => {
  EventBus.on(`consent:add${vendor}`, onAdd)
  EventBus.on(`consent:remove${vendor}`, onRemove)
  // check if a consent:add event for relevant vendor has been triggered in the past
  hasConsent(vendor).then(hasIt => hasIt && onAdd())
}

export const hasConsent = (vendor) => {
  return waitForSourcePointConsent().then(() => { return realHasConsent(vendor) })
}

const OPT_OUT_VENDORS = ['WEBTREKK', 'INFONLINE']
function realHasConsent (vendor) {
  // if sourcepoint was somehow blocked we only assume consent for opt-out vendors
  if (isSourcepointBlocked()) { return OPT_OUT_VENDORS.includes(vendor) }
  return consentedVendors().includes(vendor)
}

export const requestConsent = (vendor) => {
  try {
    window._sp_.loadPrivacyManagerModal(window._sp_.privacyManager.id, window._sp_.privacyManager.hash)
  } catch {
    EventBus.trigger('adblockFence:open')
  }
}

export const consentedVendors = () => {
  return window.nonIABVendors || []
}

export const addVendor = (vendor) => {
  if (window.nonIABVendors) {
    const vendors = _uniq([...consentedVendors(), vendor])
    window.nonIABVendors = vendors
  }
  EventBus.trigger(`consent:add${vendor}`)
}

export const removeVendor = (vendor) => {
  if (window.nonIABVendors) {
    const vendors = consentedVendors().filter((consentedVendor) => consentedVendor !== vendor)
    window.nonIABVendors = vendors
  }
  EventBus.trigger(`consent:remove${vendor}`)
}
